"use client";

import React from "react";
import { METRICS_EVENTS } from "@cede/types";
import { formatShortAddress } from "@cede/utils";
import { DeleteIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { useHubUser } from "@/hooks";
import { useMetricsEvents } from "@/hooks/data/useMetricsEvents";
import { cn } from "@/lib/utils";
import { Wallet } from "lucide-react";

const DisconnectedButtonTMA = ({ onClick }: { onClick: () => void }) => {
  const { trackEvent } = useMetricsEvents();

  const onClickHandler = () => {
    // Track when user opens connect wallet modal on Telegram
    trackEvent(METRICS_EVENTS.CONNECT_WALLET_OPEN, { platform: "telegram" });
    onClick();
  };

  return (
    <Button onClick={onClickHandler} variant="primary" size="small" leftIcon={<Wallet />}>
      Connect
    </Button>
  );
};

const ConnectedButtonTMA = ({ address, onDisconnect }: { address: string; onDisconnect: () => void }) => (
  <Button onClick={onDisconnect} variant="secondary" size="small" rightIcon={<DeleteIcon />}>
    {formatShortAddress(address)}
  </Button>
);

const LoadingWrapperTMA = ({
  ready,
  children,
  className,
}: {
  ready: boolean;
  children: React.ReactNode;
  className?: string;
}) => {
  if (!ready) {
    return (
      <div className={cn("px-3 py-2 bg-cede-bg-component rounded-button animate-pulse", className)}>
        <div className="h-4 bg-cede-skeleton rounded w-24"></div>
      </div>
    );
  }

  return <>{children}</>;
};

export const WalletButtonTMA = ({ className }: { className?: string }) => {
  const { login, logout, hubUser, authenticated, ready, userFriendlyDefiAddress } = useHubUser();
  const { trackEvent } = useMetricsEvents();

  const handleLogout = () => {
    // Track when user logs out of the application on Telegram
    trackEvent(METRICS_EVENTS.LOG_OUT, {
      lastLogoutDate: new Date().toISOString(),
      platform: "telegram",
    });
    logout();
  };

  return (
    <LoadingWrapperTMA ready={ready} className={className}>
      {authenticated && hubUser?.defiAddress ? (
        <ConnectedButtonTMA address={userFriendlyDefiAddress} onDisconnect={handleLogout} />
      ) : (
        <DisconnectedButtonTMA onClick={login} />
      )}
    </LoadingWrapperTMA>
  );
};
